const ga = window.ga || ((...args) => console.debug(`ga(${JSON.stringify(args)})`))

export const notifyGAnalyticsAboutFinishedOrder = order => {
  ga("ecommerce:addTransaction", {
    id: order.data.id,
    affiliation: order.data.app_config.site_name,
    revenue: st.exchangeMoney(order.data.total_amount_sum, order.data.product_price_currency).value,
    shipping: st.exchangeMoney(order.data.confirmation_installment_amount_sum || [], order.data.product_price_currency).value,
    tax: st.exchangeMoney(order.data.agent_earnings_sum, order.data.product_price_currency).value,
    currency: order.data.product_price_currency,
  })
  ga("ecommerce:addItem", {
    id: order.data.id,
    name: order.data.product_name,
    sku: `ST${order.data.product_id}`,
    // price: "11.99",
    // quantity: "1",
  })
  ga("ecommerce:send")
}


// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/lib/GAnalyticsTools.js